export default __webpack_public_path__ + "static/media/07_HuaTai.6301bd01.png";